angular.module('mobilezuz').filter('replaceAll', function() {
    return function(target, from, to) {
        return target.replace(new RegExp(from, 'g'), to);
    };
});